export const trimStringLength = (textString, length) => {
  return textString?.length > length
    ? textString?.substring(0, length - 3) + '...'
    : textString;
};
